const LOCALE = 'en-EN';

export const formatMoneyWithSign = (value, currency) => {
  const formatter = new Intl.NumberFormat(LOCALE, {
    currency,
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
    style: 'currency',
  });
  return formatter.format(value);
};

export const formatMoney = value => {
  const formatter = new Intl.NumberFormat(LOCALE, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  });
  return formatter.format(value);
};



// WEBPACK FOOTER //
// ./src/utils/currencyHelper.js